import { useQuery } from '@tanstack/react-query'
import React from 'react'

import CompanyFcaServices from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/CompanyFcaServices'
import IfaDetailsForm from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/IfaDetailsForm/IfaDetailsForm'
import CompanyNonFcaServices from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/CompanyNonFcaServices'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { COMPANY_TYPE_CODE } from '@/lib/constants'
import { QUERY_KEYS } from '@/lib/queryKeys'
import companyService from '@/lib/services/companyService'

interface Props {
  onUpdate?: () => void
}

const CompanyServices: React.FC<Props> = ({ onUpdate }) => {
  const currentCompany = useCurrentCompanyOrFail()
  const isIfaFirm = currentCompany.companyType.code === COMPANY_TYPE_CODE.ifa

  const companyQuery = useQuery({
    queryKey: QUERY_KEYS.company(currentCompany.id),
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: () => companyService.getCompany(currentCompany.id),
  })

  const company = companyQuery.data

  if (!company) {
    return <LoadingWidget />
  }

  return (
    <div>
      {currentCompany.isFcaFirm ? (
        <CompanyFcaServices
          company={company}
          isIfaFirm={isIfaFirm}
          onUpdate={onUpdate}
        />
      ) : (
        <CompanyNonFcaServices company={company} onUpdate={onUpdate} />
      )}

      {isIfaFirm && <IfaDetailsForm company={company} />}
    </div>
  )
}

export default CompanyServices
